/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IEcommContentTemplate5ViewProps } from './ecomm-content-template-5';
import { imageAlignment } from './ecomm-content-template-5.props.autogenerated';

/**
 *
 * EcommContentTemplate1View component
 * @extends {React.PureComponent<IEcommContentTemplate5ViewProps>}
 */
export class EcommContentTemplate5View extends React.PureComponent<IEcommContentTemplate5ViewProps> {
    public state: any = { hasMounted: false };

    public componentDidMount(): void {
        if (!this.state.hasMounted) {
            this.setState({ hasMounted: true });
        }
    }

    public render(): JSX.Element | null {
        if (!this.state.hasMounted) {
            return null;
        }

        const { config } = this.props;

        let left;
        let right;

        if (config.imageAlignment === imageAlignment.left) {
            left = this._renderImage();
            right = this._renderInfo();
        } else {
            right = this._renderImage();
            left = this._renderInfo();
        }

        const resultStyle =
            config.className && config.className !== ''
                ? `row ecomm-content-template-5 ` + `${config.className}`
                : 'row ecomm-content-template-5';

        if (config.anchorID && config.anchorID !== '') {
            const style = `anchor ` + `${resultStyle}`;

            return (
                <div id={config.anchorID} className={style}>
                    {left}
                    {right}
                </div>
            );
        }

        return (
            <div className={resultStyle}>
                {left}
                {right}
            </div>
        );
    }

    private _renderImage(): JSX.Element | null {
        const { config } = this.props;

        const result =
            config.image && config.image.src ? (
                <img src={config.image.src} alt='' role='presentation' />
            ) : (
                <div className='msc-empty_image' />
            );

        return <div className='col-12 col-sm-6 img-container'>{result}</div>;
    }

    private _renderInfo(): JSX.Element | null {
        const { config, description } = this.props;

        let result = <h6>{config.title}</h6>;

        if (config.enablePrimaryColour) {
            result = <h6 className='enable-primary-colour'>{config.title}</h6>;
        }

        const firstUrl =
            config.firstButton !== undefined
                ? config.firstButton.anchorTargetID && config.firstButton.anchorTargetID !== ''
                    ? `#${config.firstButton.anchorTargetID}`
                    : config.firstButton.link?.destinationUrl
                : null;
        const firstClassName =
            config.firstButton !== undefined
                ? (config.firstButton.className ? config.firstButton.className : '') +
                  (config.firstButton.alternateColor ? ' alternate' : '')
                : '';

        const secondUrl =
            config.secondButton !== undefined
                ? config.secondButton.anchorTargetID && config.secondButton.anchorTargetID !== ''
                    ? `#${config.secondButton.anchorTargetID}`
                    : config.secondButton.link?.destinationUrl
                : null;
        const secondClassName =
            config.secondButton !== undefined
                ? (config.secondButton.className ? config.secondButton.className : '') +
                  (config.secondButton.alternateColor ? ' alternate' : '')
                : '';

        const actions = (
            <div className='actions-container'>
                {firstUrl && (
                    <a href={firstUrl} className={firstClassName}>
                        {config.firstButton?.text}
                    </a>
                )}
                {secondUrl && (
                    <a href={secondUrl} className={secondClassName}>
                        {config.secondButton?.text}
                    </a>
                )}
            </div>
        );

        if (config.title === undefined) {
            return (
                <div className='col-12 col-sm-6 info-container'>
                    <p id={this.props.id} {...this.props.renderModuleAttributes(this.props)}>
                        {description}
                    </p>
                    {actions}
                </div>
            );
        }

        return (
            <div className='col-12 col-sm-6 info-container'>
                {result}
                <p id={this.props.id} {...this.props.renderModuleAttributes(this.props)}>
                    {description}
                </p>
                {actions}
            </div>
        );
    }
}

export default EcommContentTemplate5View;
